import {observer} from "mobx-react";
import FontBody1 from "../../../components/fonts/font-body1/font-body1";
import FontHeading4 from "../../../components/fonts/font-heading4/font-heading4";
import {FONT_COLOR, FONT_VARIANT} from "../../../components/fonts/font-props";
import IconWarning from "../../../components/icons/icon-warning/icon-warning";
import Icon from "../../../components/icons/icon/icon";
import {BUTTON_VARIANTS} from "../../../components/inputs/button-variants";
import {IButtonProps} from "../../../components/inputs/button/button";
import {ActionResultModal} from "../../../components/modal/components/action-result-modal/action-result-modal";
import CreateRmaResponseStore from "../stores/create-rma-response-store";
import useDashboardTranslation from "../../../dashboard-translation/hooks/dashboard-translation-hook";
import CreateRmaMainStoreInstanceManager, { CreateRmaMainStore } from "../stores/create-rma-main-store";
import './create-rma-response-modal.scss';

interface IProps {
    store: CreateRmaResponseStore,
    createRmaMainStore: CreateRmaMainStore
}
const CreateRmaResponseModal: React.FC<IProps> = observer(({store, createRmaMainStore}) => {
    
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-create-rma';
    const content = (
            <div className={'crma-api-response-modal'}>
                <FontHeading4 variant={FONT_VARIANT.BOLD} color={store.success ? FONT_COLOR.ACCENT1 : FONT_COLOR.ACCENT3}>
                    {store.messageTitle}
                </FontHeading4>
                <FontBody1>
                    {store.message}
                </FontBody1>
                { store.warningMessage &&
                    <div className="warning-message">
                        <Icon Component={IconWarning} color={'var( --color-accent-4)'}/>
                        <FontBody1 color={FONT_COLOR.ACCENT4}>
                            {store.warningMessage}
                        </FontBody1>
                    </div>
                }
            </div>
        );
    
    
    let buttons: IButtonProps[] = [];
    if (store.success){
        buttons = [
            { variant: BUTTON_VARIANTS.Transparent, text: getTranslation('CREATE_NEW', pageScope), onClick:() => {
                store.abortTimer();
                CreateRmaMainStoreInstanceManager.voidInstance();
                createRmaMainStore.hideResponseModal();
            } },
            { variant: BUTTON_VARIANTS.PrimaryAccent, text: getTranslation('VIEW', pageScope) + store.getTimer(), onClick:() => {
                store.abortTimer();
                store.openCreatedRma();
            } },
        ];
    }
    else {
        buttons = [
            { variant: BUTTON_VARIANTS.Dismiss, text: getTranslation('TRY_AGAIN', pageScope), onClick: () => { createRmaMainStore.hideResponseModal()} }
        ];
    }
    return (
        <ActionResultModal buttons={buttons} onClose={()=>{}} isClosedDisabled={true} title={''} content={content} success={store.success}/>
    )
})

export default CreateRmaResponseModal;